import api from "@/api";

const namespaced = true;

const state = {
  bridgeSchedule: [],
  bridgeScheduleFiles: {}
}

const getters = {
  bridgeSchedule: state => state.bridgeSchedule,
  bridgeScheduleFiles: state => state.bridgeScheduleFiles
}

const mutations = {
  SET_BRIDGE_SCHEDULE: (state, payload) => {
    state.bridgeSchedule = payload;
  },
  SET_BRIDGE_SCHEDULE_FILES: (state, payload) => {
    state.bridgeScheduleFiles = payload;
  }
}

const actions = {
  async fetchBridgeSchedule({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const params = {
        search: filterConfig.search,
        ...payload
      }
      const { data } = await api.getBridgeSchedule(params)
      if (data.error) {
        commit('SET_BRIDGE_SCHEDULE', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }

      commit('SET_BRIDGE_SCHEDULE', data.data)
      commit('Table/SET_TOTAL_DATA', data.total, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
    } catch (error) {
      throw error;
    }
  },
  async postBridgeSchedule({}, payload) {
    try {
      await api.postBridgeSchedule(payload)
    } catch ({ data }) {
      throw data
    }
  },
  async putBridgeSchedule({}, payload) {
    try {
      await api.putBridgeSchedule(payload.id, payload.form)
    } catch ({ data }) {
      throw data
    }
  },
  async deleteBridgeSchedule({}, payload) {
    try {
      await api.deleteBridgeSchedule(payload)
    } catch ({ data }) {
      throw data
    }
  },
  async fetchAllBridgeSchedule({}, payload) {
    try {
      const { data } = await api.getBridgeSchedule(payload)
      if (data.error) {
        return { data: [] }
      }
      return data
    } catch (error) {
      throw error;
    }
  },
  async downloadBridgeSchedule({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const response = await api.getBridgeScheduleExcelDownload({
        search: filterConfig.search,
        ...payload})
      if (response) {
        commit('SET_BRIDGE_SCHEDULE_FILES', response)
      }
    } catch (err) {
      throw err
    }
  },
  resetBridgeScheduleFiles({ commit }) {
    commit('SET_BRIDGE_SCHEDULE_FILES', {})
  }
}

export default { namespaced, state, getters, mutations, actions }